import { useEffect } from "preact/hooks";
import { asPdfBlob } from "../lib/pdfBlob";
import { useAccBrowseStore } from "../stores/accBrowseStore";
import { useDocumentViewerStore } from "../stores/documentViewerStore";
import { useDataManagementService } from "./useDataManagementService";

export function useAccPdfLoader() {
  const dm = useDataManagementService();
  const openDoc = useDocumentViewerStore(s => s.openDoc);
  const hub = useAccBrowseStore(s => s.hub);

  useEffect(() => {
    if (!openDoc) return;
    let cancelled = false;
    const st = useDocumentViewerStore.getState();
    st.setLoading();
    void (async () => {
      try {
        const raw = await dm.downloadItemBlob(
          openDoc.projectId,
          openDoc.itemId,
          openDoc.hubRegion ?? hub?.region
        );
        if (cancelled) return;
        const blob = asPdfBlob(raw, openDoc.fileName);
        const url = URL.createObjectURL(blob);
        useDocumentViewerStore.getState().setReady(url);
      } catch (e) {
        if (cancelled) return;
        useDocumentViewerStore
          .getState()
          .setError(e instanceof Error ? e.message : "Failed to load PDF");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [openDoc?.itemId, openDoc?.projectId, dm, hub?.region]);
}
